import { Product } from '@/types';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { staggerTransition } from '@/lib/framer-motion/stagger-transition';
import AnchorLink from '../ui/links/anchor-link';
import { useRouter } from 'next/router';
import routes from '@/config/routes';

interface WishlistDropdownProps {
  wishlists: Product[];
  isLoading: boolean;
  onClose: () => void;
}

export default function WishlistDropdown({
  wishlists,
  isLoading,
  onClose
}: WishlistDropdownProps) {
  const router = useRouter();

  return (
    <motion.div
      initial="exit"
      animate="enter"
      variants={staggerTransition()}
      className="fixed right-4 top-[60px] z-[100] w-72 rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-dark-200"
    >
      {isLoading ? (
        <div className="p-4 text-center text-sm">Loading...</div>
      ) : !wishlists.length ? (
        <div className="p-4 text-center text-sm text-gray-500">
          Nothing in your wishlist yet
        </div>
      ) : (
        <div className="overflow-y-auto">
          {wishlists.slice(0, 4).map((product) => (
            <AnchorLink
              href={`/products/${product.slug}`}
              className="group block w-full"
              key={product.id}
              onClick={onClose}
            >
              <div className="flex items-center gap-3 p-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50">
                <div className="relative h-10 w-10 overflow-hidden rounded-md">
                  <Image
                    src={product.image?.thumbnail ?? '/placeholder.svg'}
                    alt={product.name}
                    fill
                    className="object-cover"
                  />
                </div>
                
                <div className="flex flex-1 flex-col">
                  <h3 className="text-xs font-semibold">
                    {product.name}
                  </h3>
                  <span className="text-[11px] text-gray-600 dark:text-gray-400">
                    {product.shop?.name}
                  </span>
                </div>
              </div>
            </AnchorLink>
          ))}
          
          <button
            className="w-full border-t border-gray-100 p-2 text-center text-xs font-medium text-brand hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700"
            onClick={() => {
            //   router.push(routes.wishlists);
            router.push(routes.feed + '?tab=watchlists');
              onClose();
            }}
          >
            View all items
          </button>
        </div>
      )}
    </motion.div>
  );
}